export const FormCheckboxMixin = {
  props: {
    label: { type: String },
    checkboxClass: { type: [Object, String] },
    size: {
      type: String,
      required: false,
      validator: (prop) => ['is-small', 'is-medium', 'is-large'].includes(prop)
    }
  }
};
